import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "7.2",
  cy: "14.4",
  r: "3.2"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "14.8",
  cy: "18",
  r: "2"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "15.2",
  cy: "8.8",
  r: "4.8"
}, "2")], 'BubbleChartRounded');